// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img[data-v-53df8558] {\n  max-height: 90px !important;\n  max-width: initial !important;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
